import React from "react";
import { graphql } from "gatsby";
import { DoubleImageFragmentFragment } from "../../graphql-types";
import Image from "./Image";
import styles from "../styles/DoubleImage.module.scss";

type Props = { data: DoubleImageFragmentFragment };

const DoubleImage = ({ data }: Props) => {
  const { image_1, image_2 } = data.elements;
  const caption_1 = image_1.value[0].elements.caption?.value;
  const caption_2 = image_2.value[0].elements.caption?.value;

  return (
    <div className={styles["DoubleImage"]}>
      <figure>
        <Image data={image_1.value[0]} />
        {caption_1 && <figcaption>{caption_1}</figcaption>}
      </figure>
      <figure>
        <Image data={image_2.value[0]} />
        {caption_2 && <figcaption>{caption_2}</figcaption>}
      </figure>
    </div>
  );
};

export default DoubleImage;

export const query = graphql`
  fragment DoubleImageFragment on kontent_item_double_image {
    elements {
      image_1 {
        value {
          ...ImageFragment
        }
      }
      image_2 {
        value {
          ...ImageFragment
        }
      }
    }
  }
`;
